import { ProductConnectivityState, ProductPeripheralsState } from '../data'
import { StoreError } from '../error'

export enum TestState {
  IDLE = 'Idle', // Test waiting for startup
  READY = 'Ready', // Test ready to start
  STARTING = 'Starting', // iBeacon permissions and BLE Manager starting
  WAITING = 'Waiting', // Waiting for battery charging mode
  SCANNING = 'Scanning', // BLE Manager is scanning for bluetooth devices
  RANGING = 'Ranging', // Scanning and ranging iBeacons
  READING = 'Reading', // BLE Manager is reading characteristics of device
  COMPLETED = 'Completed', // Test completed
  FAILED = 'Failed', // Test has failed.
}

export enum Warning {
  SENSOR_NOT_VERIFIED = 'Sensor connection not verified',
  SENSOR_NOT_OCCUPIED = 'Sensor does not report occupied',
  LED_NOT_VERIFIED = 'Led connection not verified',
  LED_NOT_CONNECTED = 'Led disconnected',
  SIGNAL_LOW = 'Signal strength is low',
}

export { BatteryState } from 'expo-battery'

export enum Connection {
  CONNECTED = 'C',
  DISCONNECTED = 'D',
  UNOCCUPIED = 'U',
  OCCUPIED = 'O',
}

export enum Diagnostic {
  Unknown = 0,
  Attaching,
  PowerUp,
  Sending,
  Waiting,
  ErrorNotAttached,
  ErrorAttached,
}

export enum IdentifyState {
  IDLE = 'Idle', // Identification waiting for startup
  STARTING = 'Starting', // iBeacon permissions and BLE Manager starting
  PREPARING = 'Preparing', // Preparing for identification
  WAITING = 'Waiting', // Waiting for battery charging mode
  RANGING = 'Ranging', // Scanning and ranging iBeacons
  COMPLETED = 'Completed', // Identification completed
  FAILED = 'Failed', // Identification has failed.
}

export interface Device {
  name: string
}

export interface DeviceValidationResult {
  isValid: boolean
  expectedDevice?: Device
}

export interface DiagnosticValidationResult {
  isValid: boolean
  isAttached: boolean
  isSensorConnected: boolean
  isLedConnected: boolean
  connectivityState?: ProductConnectivityState
  peripheralsState?: ProductPeripheralsState
}

export interface Config {
  validateDevice?: (device: Device) => DeviceValidationResult
  validateDiagnostic?: (diagnostic: string) => DiagnosticValidationResult
}
